import React, { useContext } from "react";
import { Card, CardBody } from "reactstrap";
import { ThemeContext } from "contexts/ThemeContext";

function HalfCircleGauge({
  title,
  percent = 0,
  subtitle,
  color = "#2dce89",
  onClick,
}) {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const radius = 80;
  const strokeWidth = 12;

  // ✅ HALF circle length (UNCHANGED)
  const halfCircumference = Math.PI * radius;

  const clampedPercent = Math.max(0, Math.min(percent, 100));

  // ✅ Correct dash offset for HALF circle (UNCHANGED)
  const dashOffset =
    halfCircumference * (1 - clampedPercent / 100);

  // ✅ THEME-AWARE COLORS (ONLY CHANGE)
  const trackColor = isDark ? "#374151" : "#e9ecef";
  const textColor = isDark ? "#e5e7eb" : "#32325d";

  return (
    <Card
      className={`shadow-sm text-center ${
        onClick ? "cursor-pointer hover-shadow" : ""
      }`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <CardBody>
        <h5 className="mb-2">{title}</h5>

        <svg width="200" height="110" viewBox="0 0 200 110">
          {/* Background arc */}
          <path
            d="M 20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke={trackColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />

          {/* Progress arc */}
          <path
            d="M 20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={halfCircumference}
            strokeDashoffset={dashOffset}
            style={{
              transition: "stroke-dashoffset 0.8s ease",
            }}
          />

          {/* Percentage label */}
          <text
            x="100"
            y="85"
            textAnchor="middle"
            fontSize="22"
            fontWeight="600"
            fill={textColor}
          >
            {clampedPercent}%
          </text>
        </svg>

        {subtitle && (
          <small className="text-muted d-block mt-1">
            {subtitle}
          </small>
        )}
      </CardBody>
    </Card>
  );
}

export default HalfCircleGauge;
